import ruLocale from "antd/es/locale/ru_RU";
import uaLocale from "antd/es/locale/uk_UA";
import "moment/dist/locale/uk";
import "moment/dist/locale/ru";
import moment from "moment";
import type { Locale } from "antd/es/locale-provider";

export const antLocales: Record<string, Locale> = { ru: ruLocale, ua: uaLocale };

export const initLocalization = async (lang: string) => {
  const [i18n, { initReactI18next }] = await Promise.all([
    import("i18next"),
    import("react-i18next"),
  ]);

  await i18n.use(initReactI18next).init({
    resources: {},
    lng: lang,
    fallbackLng: "ru",
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18nStore: "added",
    },
  });

  moment.locale(lang === "ua" ? "uk_UA" : "ru_RU");
};
